import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../Reusable/Footer";
import NavigationBar from "../Reusable/NavigationBar";
import ScrollToTop from "../Reusable/ScrollToTop";
// import More from "../Reusable/More";
import MeetFobs from "./MeetFobs";
import Summary from "./Summary";
import Experience from "./Experience";
import Skills from "./Skills";

const About = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		document.title = "About Oluwatobi Fabusuyi (Fobs Designs)";
		window.scrollTo(0, 0);

		return () => {
			document.title = "Oluwatobi Fabusuyi";
		};
	}, [pathname]);

	return (
		<div className="homepage about-page">
			<NavigationBar />
			<MeetFobs />
			<Summary />
			<Experience />
			<Skills />
			{/* <More /> */}
			<Footer />
			<ScrollToTop />
		</div>
	);
};

export default About;
